import {useNavigate} from 'react-router-dom';
import {Alert, AlertDescription} from '@/components/ui/alert.tsx';
import {Button} from '@/components/ui/button.tsx';
import {DayPickerField} from '../../../components/day-picker-field';
import {LoadingSpinner} from '../../../components/LoadingSpinner';
import {StockMatrixDataTable} from './stock-matrix-data-table';
import {useStocksPage} from './use-stocks-page';

export function StocksPage() {
	const navigate = useNavigate();
	const state = useStocksPage();

	return (
		<div className="mx-auto w-full min-w-0 max-w-full p-4">
			<div className="mb-4 flex items-center justify-between gap-3">
				<h1 className="text-xl font-semibold tracking-tight">Остатки</h1>
				<Button type="button" variant="ghost" size="sm" onClick={() => navigate('/ozon')}>
					Назад
				</Button>
			</div>

			<div className="flex flex-col gap-3">
				<div className="flex w-full max-w-[700px] flex-wrap gap-3">
					<DayPickerField
						id="ozon-stocks-from"
						label="С"
						value={state.from}
						onChange={state.setFrom}
						max={state.to}
					/>
					<DayPickerField
						id="ozon-stocks-to"
						label="По"
						value={state.to}
						onChange={state.setTo}
						min={state.from}
					/>
				</div>

				{state.error && (
					<Alert variant="destructive">
						<AlertDescription>{state.error}</AlertDescription>
					</Alert>
				)}

				{state.loading && !state.error && <LoadingSpinner compact/>}

				{state.showEmpty && (
					<p className="text-sm text-muted-foreground">За выбранный период нет остатков</p>
				)}

				{state.showTable && state.matrix && state.nameByOfferId && (
					<StockMatrixDataTable matrix={state.matrix} nameByOfferId={state.nameByOfferId}/>
				)}
			</div>
		</div>
	);
}
